import React,{ useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './UploadedDocs.css';
import ReactPaginate from 'react-paginate';
import { useAppConfig } from '../../AppConfigProvider';
import { faSearch, faBuilding } from '@fortawesome/free-solid-svg-icons';
import Supliers from '../Supliers/Supliers';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UploadedDocs = ({load,setLoad,SuplierRender,uId}) => {
  const appConfig = useAppConfig();
  const userIDD = uId;

const [suppliers, setSuppliers] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [suppliersPerPage] = useState(10);

const [searchQuery,setSearchQuery]=useState("");

const search=(data)=>{
  console.log("searchQuery : ",searchQuery);
  return data.filter((item)=> item.vendorName.toLowerCase().includes(searchQuery));
}
const sortSuppliers=(arr)=>{
  return arr.sort(function(a, b) {
    var textA = a.vendorName.toUpperCase();
    var textB = b.vendorName.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;});
}


const DeleteSup =async (id)=>{
    console.log(id);
    setLoad(true);
    await axios.patch(`${appConfig.backendUrl}api/v1/supplier/deleteSupplier/${id}`, null).then(function(response){
             console.log("Sss");
             console.log(response.data);
             fetchSuppliers();
             setLoad(false);
             toast.success("Supplier deleted successfully", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
    }).catch(err => {
      setLoad(false);
      toast.error(`${err}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
}
  const fetchSuppliers = useCallback(async () => {
    setLoad(true);
    const res = await axios.get(`${appConfig.backendUrl}api/v1/supplier/suppliers/${userIDD}`);
    console.log("res::::", res.data);
    setSuppliers(sortSuppliers(res.data));
    setLoad(false);

  }, [appConfig.backendUrl, setLoad, userIDD]);
useEffect(() => {
  fetchSuppliers();
  }, [fetchSuppliers]);

// Get current Suppliers
const indexOfLastSuppliers = currentPage * suppliersPerPage;
const indexOfFirstSuppliers = indexOfLastSuppliers - suppliersPerPage;
const currentSuppliers = search(suppliers).slice(indexOfFirstSuppliers, indexOfLastSuppliers);

// Change page
const paginate = pageNumber => setCurrentPage(pageNumber);

const handlePageClick=(data)=>{
   paginate(data.selected+1);
}
const totalNoOfPages= Math.ceil(search(suppliers).length / suppliersPerPage);





return (
  <div className='pushqb-container'>
    <div className="page-header">
      <h1 className="page-title">
        <FontAwesomeIcon icon={faBuilding} />
        Suppliers
      </h1>
      <p className="page-subtitle">Manage and review your supplier accounts</p>
    </div>
    {!load && <div className="input-group  btn-radius relative search-wrap">
      <input type="text" id="searchQueryInput" placeholder="Search" className="search form-control btn-input" onChange={(e)=>setSearchQuery(e.target.value)}/>
      <span className="faEyeIcon" >
          <FontAwesomeIcon icon={faSearch} />
      </span>
      </div> }
    <Supliers suppliers={currentSuppliers} load={load} SuplierRender={SuplierRender} DeleteSup={DeleteSup} setSuppliers={setSuppliers}/>
    {/* <Pagination
      suppliersPerPage={suppliersPerPage}
      totalPosts={suppliers.length}
      paginate={paginate}
    /> */} 
    {totalNoOfPages>=1 && !load &&  <ReactPaginate previousLabel={'◀'} nextLabel={'▶'} breakLabel={'...'} pageCount={totalNoOfPages} marginPagesDisplayed={3}
    pageRangeDisplayed={10} onPageChange={handlePageClick} containerClassName={'pagination'} pageClassName={'page-item'}
    pageLinkClassName={'page-link'} previousClassName={'page-item'} previousLinkClassName={'page-link'} nextClassName={'page-item'} nextLinkClassName={'page-link'}
    breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'}  firstLabel={'First'}
    lastLabel={'Last'}/>}

    {totalNoOfPages<=0 && !load && <h5 className='e-msg'>Opps! Nothing to show</h5>}
    <ToastContainer />
  </div>
);
}

export default UploadedDocs